package fr.manyverse.app.presentation.theme

import androidx.compose.ui.unit.dp

/**
 * Design system spacing values for consistent layouts.
 *
 * Usage:
 * ```kotlin
 * Spacer(modifier = Modifier.height(Spacing.medium))
 * Modifier.padding(Spacing.large)
 * ```
 */
object Spacing {
    /** 4.dp - Minimal spacing for tight layouts */
    val extraSmall = 4.dp

    /** 8.dp - Small spacing for closely related elements */
    val small = 8.dp

    /** 12.dp - Compact spacing between form fields */
    val compact = 12.dp

    /** 16.dp - Default padding and spacing */
    val medium = 16.dp

    /** 24.dp - Larger spacing for section separation */
    val large = 24.dp

    /** 32.dp - Extra large spacing for major sections */
    val extraLarge = 32.dp

    /** 48.dp - Spacing after titles/headings */
    val huge = 48.dp

    /** 64.dp - Top padding for main content areas */
    val contentTop = 64.dp
}
